import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_PAYOUT_ACCOUNT } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import i18n from "../../i18n";
// API: GET /api/v1/payment/settlements?provider_type=nurse&status=&payment_method=&search=&date_from=&date_to=&page=&limit=
export const fetchProviderSettlementsReducer = createAsyncThunk(
  ACTION_PAYOUT_ACCOUNT.fetch_provider_settlements,
  async (
    {
      provider_type = "nurse",
      order_type = "",
      status = "",
      payment_method = "",
      search = "",
      date_from = "",
      date_to = "",
      page = 1,
      limit = 10,
    } = {},
    { rejectWithValue }
  ) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const queryParams = new URLSearchParams({ provider_type, page, limit });
      if (order_type) queryParams.append("order_type", order_type);
      if (status) queryParams.append("status", status);
      if (payment_method) queryParams.append("payment_method", payment_method);
      if (search) queryParams.append("search", search);
      if (date_from) queryParams.append("date_from", date_from);
      if (date_to) queryParams.append("date_to", date_to);

      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getProviderSettlements}?${queryParams.toString()}`
      );
      if (response?.data?.status === true || response?.status === 200) {
        return response.data.data;
      }
      return rejectWithValue(response?.data?.message || i18n.t("toast.failedToFetchWithdrawals"));
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || i18n.t("toast.failedToFetchWithdrawals"));
    }
  }
);
